// Constellation System API
// Milestone 3: API Layer

const API_BASE = window.location.origin;

/**
 * Fetch constellation data for the current user
 * 
 * @param {number} [limit=100] - Maximum number of connections to return
 * @returns {Promise<Object>} Constellation response with core_star, nodes, edges, stats, and _degraded flag
 */
export async function fetchConstellationMe(limit = 100) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/constellation/me?limit=${limit}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch constellation data');
  }
  
  // Check for degraded mode header
  const isDegraded = res.headers.get('X-UnityLove-Degraded') === '1';
  const degradedCount = parseInt(res.headers.get('X-UnityLove-Degraded-Count') || '0', 10);
  
  const data = await res.json();
  
  // Attach degraded info to response
  return {
    ...data,
    _degraded: isDegraded,
    _degradedCount: degradedCount,
  };
}

/**
 * Fetch global constellation view (regional aggregation)
 * 
 * @returns {Promise<Object>} Global constellation response with regions, total_connections, countries_count
 */
export async function fetchConstellationGlobal() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/constellation/global`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch global constellation data');
  }
  
  return res.json();
}
